import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GridTableParametersService } from 'src/app/template/gridTemplate/gridTableParameters.service';
import { NewRequestForm, CoordinateSearchForm, MapForm, OverviewForm, MapConfig, MapOptions, MapText } from './new-request-model';
import { FormularService } from 'src/app/Services/formular.service';
import { CommonService } from 'src/app/Services/common.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { AuthentService } from 'src/app/Services/authent.service';

declare function getSources(params, refresh, readonly): any;


@Component({
  selector: 'app-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.css']
})
export class NewRequestComponent implements OnInit {

  constructor(
    private shareData: SharingDataService,
    public grid: GridTableParametersService,
    public formularService: FormularService,
    private commonService: CommonService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private authentService: AuthentService,
  ) { }

  resourceDefinition;
  gipDefault;

  MapServicesUrl = {}

  NewRequestForm = NewRequestForm;
  CoordinateSearchForm = CoordinateSearchForm;
  MapForm = MapForm;
  OverviewForm = OverviewForm;
  MapConfig = MapConfig;
  MapOptions = MapOptions;
  MapText = MapText;

  isEditable

  @ViewChild('stepper') public stepper: MatStepper;

  ngOnInit(): void {
    var NewRequestForm = NewRequestForm;
    var CoordinateSearchForm = CoordinateSearchForm;
    var MapForm = MapForm;
    var OverviewForm = OverviewForm;
    var MapConfig = MapConfig;
    var MapOptions = MapOptions;
    var MapText = MapText;

    this.isEditable = true;
    this.shareData.currentResourceDefinition.subscribe(data => {
      this.resourceDefinition = data;
      this.getText();
      var params = {
        MapText: this.MapText,
      };
      this.authentService.getToken().then(async token => {
        getSources(params, false, false)
      })
    });
    this.shareData.currentGipDefault.subscribe(data => this.gipDefault = data);

    this.MapServicesUrl = this.commonService.getGipServicesUrl();
    this.fillMapConfig();
  }

  MapOrManualRequestDisplay = "Map";


  fillMapConfig() {
    this.gipDefault.forEach(element => {
      if (element.GIP_NAME == "EPSERVICESURL_PUB") { this.MapConfig.epServicesUrl = element.GIP_VALUE }
      if (element.GIP_NAME == "PROJECTIONINITNAME") { this.MapConfig.projectionInitName = element.GIP_VALUE }
      if (element.GIP_NAME == "PROJECTIONINITDEF") { this.MapConfig.projectionInitDef = element.GIP_VALUE }
      if (element.GIP_NAME == "PROJECTIONDEFAULT") { this.MapConfig.projectionDefault = element.GIP_VALUE }
      if (element.GIP_NAME == "WL_COORDXMIN") { this.MapConfig.mapBoundminX = element.GIP_VALUE }
      if (element.GIP_NAME == "WL_COORDYMIN") { this.MapConfig.mapBoundminY = element.GIP_VALUE }
      if (element.GIP_NAME == "WL_COORDXMAX") { this.MapConfig.mapBoundmaxX = element.GIP_VALUE }
      if (element.GIP_NAME == "WL_COORDYMAX") { this.MapConfig.mapBoundmaxY = element.GIP_VALUE }
      if (element.GIP_NAME == "MAPMINZOOM") { this.MapConfig.mapMinZoom = element.GIP_VALUE }
      if (element.GIP_NAME == "MAPLOADZOOM") { this.MapConfig.mapLoadZoom = element.GIP_VALUE }
      if (element.GIP_NAME == "MAXMAPGEOMETRIES") { this.MapConfig.maxGeometries = element.GIP_VALUE }
      if (element.GIP_NAME == "MAXMAPGEOMETRIES_POINT") { this.MapConfig.maxGeometriesPoint = element.GIP_VALUE }
      if (element.GIP_NAME == "MAXMAPGEOMETRIES_LINE") { this.MapConfig.maxGeometriesLine = element.GIP_VALUE }
      if (element.GIP_NAME == "MAXMAPGEOMETRIES_POLYGON") { this.MapConfig.maxGeometriesPolygon = element.GIP_VALUE }
      if (element.GIP_NAME == "PLOTFRAMEMAXDIST") { this.MapConfig.maxDistance = element.GIP_VALUE }
      if (element.GIP_NAME == "PLOTFRAMEOVERLAP") { this.MapConfig.checkOverlap = element.GIP_VALUE }
    });
  }

  disableEditable() {
    this.isEditable = false;
  }


  updateRequestModel(canGetConfig?: boolean) {
    if (this.CoordinateSearchForm.value["SEARCH_METHOD"] == "3") {
      this.MapOrManualRequestDisplay = "Manual";
    } else {
      this.MapOrManualRequestDisplay = "Map";
    }


    for (var overviewElement in this.OverviewForm.value) {
      for (var newRequestFormElement in this.NewRequestForm.value) {
        if (overviewElement == newRequestFormElement) {
          this.OverviewForm.controls[overviewElement].setValue(this.NewRequestForm.value[newRequestFormElement])
        }
      }
      for (var coordinateSearchFormElement in this.CoordinateSearchForm.value) {
        if (overviewElement == coordinateSearchFormElement) {
          this.OverviewForm.controls[overviewElement].setValue(this.CoordinateSearchForm.value[coordinateSearchFormElement])
        }
      }
      for (var mapFormElement in this.MapForm.value) {
        if (overviewElement == mapFormElement) {
          this.OverviewForm.controls[overviewElement].setValue(this.MapForm.value[mapFormElement])
        }
      }
    }

    if(this.CoordinateSearchForm.value.SEARCH_METHOD == "1"){
      // this.OverviewForm.controls.LOCATION.setValue(`${this.CoordinateSearchForm.value.STREET} ${this.CoordinateSearchForm.value.VPO_HOUSENUMBER_DEFAULT} ${this.CoordinateSearchForm.value.VPO_MUNICIPALITY_DEFAULT} ${this.CoordinateSearchForm.value.ZIP}`)
      this.OverviewForm.controls.PARCEL_ID.setValue(null);
    } else if(this.CoordinateSearchForm.value.SEARCH_METHOD == "2"){
      // this.OverviewForm.controls.LOCATION.setValue(`${this.CoordinateSearchForm.value.VPO_CADASTRALUNIT_DEFAULT} ${this.CoordinateSearchForm.value.VPO_NOMINATOR_DEFAULT} ${this.CoordinateSearchForm.value.VPO_DENOMINATOR_DEFAULT}`)
      this.OverviewForm.controls.ADDRESS_ID.setValue(null);
    } else if(this.CoordinateSearchForm.value.SEARCH_METHOD == "3"){
      this.OverviewForm.controls.PARCEL_ID.setValue(null);
      this.OverviewForm.controls.ADDRESS_ID.setValue(null);
    } else if(this.CoordinateSearchForm.value.SEARCH_METHOD == "4"){
      this.OverviewForm.controls.PARCEL_ID.setValue(null);
      this.OverviewForm.controls.ADDRESS_ID.setValue(null);
    }
    
    if (canGetConfig) {
      this.getConfig();
    }
  }

  getText(){
    for (var element in this.MapText) {
      this.MapText[element] = this.translateResourceDefinition.transform(element, this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common");
    }
  }

  getConfig() {
    this.getText();

    this.MapOptions.role = this.authentService.currentUser().ROLE;
    this.MapOptions.scale = this.MapForm.value.SCALE;
    this.MapOptions.x = this.CoordinateSearchForm.value.X_LOC_COORD;
    this.MapOptions.y = this.CoordinateSearchForm.value.Y_LOC_COORD;
    if (this.MapForm.value.PLOT_FORMAT != null) {
      var PlotFormat = this.MapForm.value.PLOT_FORMAT.split("/");
      this.MapOptions.pageWidth = PlotFormat[0];
      this.MapOptions.pageHeight = PlotFormat[1];
      this.MapOptions.pageOverlap = PlotFormat[2];
    }


    var params = {
      MapConfig: this.MapConfig,
      MapOptions: this.MapOptions,
      MapText: this.MapText,
      MapServicesUrl: this.MapServicesUrl,
    };

    this.authentService.getToken().then(async token => {
      getSources(params, true, false)
    })
  }
}
